<template>
    <div class="main-content">
        <the-header :title="title" v-if="title !== undefined"
                    :buttons="headerButtons"
                    @button-notify="notify($route.params.id)"
                    @button-create="createApplication()"
        />
        <ul class="nav nav-pills-tabs nav-pills nav-fill mb-3" v-if="$route.name !== 'createPatient'">
            <li class="nav-item">
                <router-link :to="getTabLink('base')" class="nav-link">
                    {{t('Patient details')}}
                </router-link>
            </li>
            <li class="nav-item" v-if="hasPermission('ApplicationsTitan', 'R')">
                <router-link :to="getTabLink('applications')" class="nav-link">
                    {{t('Applications')}}
                </router-link>
            </li>
        </ul>
        <patient-form ref="patientForm"
                      :form-data="patientData"
                      :newItem="$route.name === 'createPatient'"
                      v-if="currentTab === 'base'"
                      @saveData="saveData()"
                      :editable="hasPermission('PatientsTitan', 'U')"
        />
        <grid :show-patient="false"
              :patientId="parseInt($route.params.id)"
              v-if="currentTab === 'applications'"
        />

        <notification ref="notifyPatient"/>
        <b-modal
          ref="duplicatePatientModal"
          :title="t('Duplicate birth number')"
          ok-only
          >
          <p>
            {{t('A patient with given birth number already in the system.')}}
          </p>
          <p>
            {{t('Patient')}}: <strong>{{duplicatePatient.fullName}}</strong><br>
            {{t('Birth number')}}: <strong>{{duplicatePatient.birthNumber}}</strong><br>
          </p>
          <p>
            <router-link :to="{name: 'managePatient', params: { id: duplicatePatient.id, tab: 'base' }}">
              {{t('Open patient page')}}
            </router-link>
          </p>
        </b-modal>
    </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import TimeLine from '../../../core/TimeLine';
    import TitanForm from '../../../core/Form/Form'
    import Grid from '../applications/grid';
    import PatientForm from './form';
    import Loading from '../../../core/Components/loading';
    import Notification from './notification';

    export default {
        components: {
            Notification,
            TimeLine,
            TheHeader,
            TitanForm,
            Grid,
            PatientForm,
            Loading,
        },
        computed: {
            currentTab() {
                return this.$route.params.tab;
            },
            patientData() {
                return this.$store.state.patients.item;
            },
            title() {
                if ('createPatient' === this.$route.name) {
                    return this.t('Add patient');
                } else if (0 === this.patientData.length || this.patientData.fullName === undefined) {
                    return this.t('Edit patient');
                }
                return this.patientData.fullName;
            },
            headerButtons() {
                let buttons = [];
                if (this.$route.name !== 'createPatient') {
                    buttons.push({
                        type: 'button',
                        key: 'notify',
                        name: this.t('Notify'),
                        icon: 'bell',
                        styleClass: 'btn-warning',
                        visible: () => {
                            return this.isNotIntKar();
                        },
                    });

                    buttons.push({
                        type: 'link',
                        to: {name: 'selectApplicationUser',params: {patientId: this.patientData.id}},
                        // type: 'button',
                        key: 'create',
                        name: this.t('Create application'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                        visible: () => {
                            return this.hasPermission('ApplicationsTitan', 'C');
                        },
                    });
                }

                return buttons;
            },
        },
        mounted() {
            this.initData();
            this.loadPatients();
        },
        methods: {
            notify() {
                this.$refs.notifyPatient.openModal(this.patientData);
            },
            createApplication() {
                this.$store.dispatch('applications/create', {patient: this.$route.params.id}).then(res => {
                    this.$router.push({
                        name: 'manageApplication',
                        params: {
                            id: res.id,
                        },
                    });
                });
            },
            initData() {
                this.resetPatient();

                if ('managePatient' === this.$route.name) {
                  this.loading = true;
                  this.$store.dispatch('patients/get', this.$route.params.id).then(() => {
                    this.loading = false;
                  }).catch(() => {
                    this.loading = false;
                  });
                }
            },
            resetPatient() {
                this.$store.commit('patients/setItem', {
                    patientAddress: [],
                });
            },
            getTabLink(tab) {
                return {
                    name: 'managePatient',
                    params: {
                        id: this.$route.params.id,
                        tab: tab,
                    },
                }
            },
            loadPatients() {
              this.$store.dispatch('patients/list').then(response => {
                this.patients = response.items
              })
            },
            checkForUniqueBirthNumber(type, callback) {
                const { birthNumber, id } = this.patientData
                const hasExistingBirthNumber = this.patients.find(patient => {
                  return patient.id !== id && patient.birthNumber === birthNumber
                })

                if (hasExistingBirthNumber) {
                    console.warn('found patient with given birthNumber')
                    console.info({hasExistingBirthNumber})
                    this.duplicatePatient = hasExistingBirthNumber
                    this.$refs.duplicatePatientModal.show()
                    return
                }

                callback()
            },
            saveData() {
                if (true === this.$refs.patientForm.isValid()) {
                    const type = 'managePatient' === this.$route.name ? 'patients/update' : 'patients/create';
                    this.checkForUniqueBirthNumber(type, () => {
                      this.$store.dispatch(type, this.patientData).then(response => {
                        if(type === 'patients/create' ) {
                          this.$router.push({
                            name: 'managePatient',
                            params: {
                              id: response.id,
                              tab: 'base',
                            },
                          });
                        }
                      });
                    })
                } else {
                    this.$store.dispatch('alert/warning', this.t('Form has invalid data. Check it and try again.'));
                }
            },
        },
        watch: {
            '$route.params'(newValue, oldValue) {
                if (!oldValue.hasOwnProperty('id') && newValue.hasOwnProperty('id')) {
                    this.$refs.duplicatePatientModal.hide()
                    this.initData()
                }
            },
        },
        data() {
            return {
                loading: true,
                patients: [],
                duplicatePatient: {
                  id: 0,
                  fullName: '',
                  birthNumber: '/'
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/patients/manage.vue